export const convertCurrency = (price) => {
    return `${parseFloat(price).toFixed(3)} DT`
}